<template>
  <b-container>
    <b-row>
      <b-col sm="12" md="6" lg="6">
        <h1>{{ $t("tracking.vehicleType.edit") }}</h1>
        <success-fade-alert ref="alert" :msg="alert.success" />
        <fade-alert-danger ref="danger" :msg="alert.error" />

        <b-row class="mb-3 ml-0">
          <router-link :to="getUrlBackToList">
            <b-button size="sm">{{ $t("geral.backtolist") }}</b-button>
          </router-link>
        </b-row>

        <vehicle-type-crud-data
          :model="model"
          :modelstate="modelstate"
          :readonly="!canEdit"
          class="mb-4"
        >
        </vehicle-type-crud-data>

        <b-button class="button" @click="save" :disabled="canSubmit">
          {{ $t("geral.save") }}
        </b-button>
      </b-col>
    </b-row>
    <!-- {{ model }} -->
  </b-container>
</template>

<script>
import FadeAlertDanger from "@/components/FadeAlertDanger.vue";
import SuccessFadeAlert from "@/components/SuccessFadeAlert.vue";

export default {
  name: "VehicleTypeEdit",
  components: {
    FadeAlertDanger,
    SuccessFadeAlert,
    VehicleTypeCrudData: () =>
      import("@/components_rms/tracking/vehicleType/VehicleTypeCrudData.vue"),
  },
  props: {
    id: String,
    companyId: String,
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Registro criado com sucesso",
      },
      submitted: false,
      modelstate: [],
      model: {
        companyId: 0,
        vehicleTypeId: 0,
        vehicleTypeActive: true,
        vehicleTypeDescription: "",
        vehicleTypeName: "",
      },
    };
  },
  created() {
    this.loadData();
  },
  computed: {
    canEdit() {
      if (this.model) {
        if (this.model.vehicleTypeActive) {
          return true;
        }
      }
      return false;
    },
    canSubmit() {
      if (this.submitted) {
        return true;
      }
      if (!this.canEdit) {
        return true;
      }
      return false;
    },
    getUrlBackToList() {
      if (this.companyId) {
        return `../../vehicleType/list/${this.companyId}`;
      }     
      return `../../vehicleType/list`;
    },
    getUrlVehicleTypeList() {
      if (this.companyId) {
        return `vehicleType/get/${this.id}/${this.companyId}`;
      }     
      return `vehicleType/get/${this.id}`;
    }
  },
  methods: {
    async loadData() {
      this.$api
        .get(this.getUrlVehicleTypeList)
        .then((response) => {
          this.model = response.data;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            if (error.response) {
              if (error.response.status == 400) {
                this.modelstate = error.response.data.errors;
              }
            }
            this.alert.error = error.message;
            this.$refs.danger.show();
          }
        });
    },
    save() {
      this.submitted = true;
      this.$api
        .post("/vehicleType/edit/" + this.model.vehicleTypeId.toString(), this.model)
        .then((response) => {
          this.model = response.data;
          this.$refs.alert.show();
          this.modelstate = [];
          this.submitted = false;
        })
        .catch((error) => {
          this.submitted = false;
          this.modelstate = [];

          if (error.response) {
            if (error.response.status == 400) {
              this.modelstate = error.response.data.errors;
            }
          }
          this.alert.error = error.message;
          this.$refs.danger.show();
        });
    },
  },
};
</script>
